var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSkipPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4667 2.98344L6.00835 9.30844C5.45002 9.68344 5.45002 10.5001 6.00835 10.8668L15.475 17.1918C16.1 17.6084 16.9333 17.1584 16.9333 16.4084V3.76677C16.9333 3.01677 16.0917 2.56677 15.4667 2.98344Z",
    fill: "#006CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55001 17.1836C3.09167 17.1836 2.71667 16.8086 2.71667 16.3502V3.65023C2.71667 3.19189 3.09167 2.81689 3.55001 2.81689C4.00834 2.81689 4.38334 3.19189 4.38334 3.65023V16.3502C4.38334 16.8086 4.00834 17.1836 3.55001 17.1836Z",
    fill: "#006CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkipPrevious);
export default __webpack_public_path__ + "static/media/icon-skip-previous.babc7bc7363bbe50c06561001a68e73a.svg";
export { ForwardRef as ReactComponent };